module.exports = __webpack_public_path__ + "7743039b5e5fab9b1262fb07a0e69f19.jpg";